import { BusinessCaseLeadRequest, BusinessCaseLeadResponse } from "./businessCaseApi.types";

export class BusinessCaseApiError extends Error {
  constructor(public errors: string[] = []) {
    super("Business case request failed");
  }
}

async function post(path: string, payload: BusinessCaseLeadRequest): Promise<BusinessCaseLeadResponse> {
  const csrfToken = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content;
  const response = await fetch(path, {
    method: "POST",
    credentials: "same-origin",
    headers: {
      "Content-Type": "application/json",
      ...(csrfToken ? { "X-CSRF-Token": csrfToken } : {}),
    },
    body: JSON.stringify(payload),
  });
  const data = await response.json();

  if (!response.ok) throw new BusinessCaseApiError(data.errors);
  return data;
}

// Calculates the case and alerts sales. Nothing reaches the visitor's inbox from here.
export const submitBusinessCaseLead = async (payload: BusinessCaseLeadRequest) =>
  post("/business_case_leads", payload);

// The only call that emails the visitor — triggered by the CTA on the result step.
export const requestBusinessCaseEmail = async (payload: BusinessCaseLeadRequest) =>
  post("/business_case_leads/email", payload);
